import React, { useEffect, useState } from 'react'
import '../ClosureMail/ClosureMail.css'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { setClosureMail } from '../../../erpStore/actions';
import { useRef } from 'react';
import incubatorLogo from "../../../assets/images/Incubator.png";
import { toast } from 'react-toastify';


function ClosureMail() {

  const [updatedtskList, setUpdatedTskList] = useState([])
  const dStatuses = useSelector((state) => state.data.statusList)
  const [statuses, setStatuses] = useState(dStatuses)

  const dispatch = useDispatch()
  const selfInfo = useSelector((state) => state.data.selfData)
  const url = useSelector((state) => state.data.apiUrl)

  const [toEmailList, setTOEMailList] = useState(selfInfo.empHigherAuthEmails)
  const [glabalEmailsList, setGlobalEmailList] = useState([])
  const [ccEmailList, setCCEmailList] = useState([])
  const [bccEmailList, setBCCEmailList] = useState([]);
  const [loaderBtn, setLoaderBtn] = useState(false)


  const [ccContainer, setCCConatiner] = useState(false)
  const [bccContainer, setBCCConatiner] = useState(false)

  const [toListOption, setToLitOption] = useState(true)
  const [ccListOption, setCCListOption] = useState(false)
  const [bccListOption, setBCCListOption] = useState(false)

  const [flagToEmailList, SetFlagToEmailList] = useState(false)
  const [flagCCEmailList, setFlagCCEmailList] = useState(false)
  const [flagBCCEmailList, setFlagBCCEmailList] = useState(false)


  const [completedTaskList, setCompletedTaskList] = useState([])
  const [pendingTaskList, setPendingTaskList] = useState([])
  const [notStartedTaskList, setNotStartedTaskList] = useState([])
  const [inDicussionTaskList, setDiscussionTaskList] = useState([])
  const [submittedTaskList, setSubmittedTaskList] = useState([])


  const [closureTaskDetaiView, setClosureTaskDetailView] = useState(false)
  const [taskIdForView, setTaskIdForView] = useState(null)


  const [taskCount, setTaskCount] = useState(0)

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
  const day = String(today.getDate()).padStart(2, '0');

  const todayDate = `${year}/${month}/${day}`;


  const stringHeaders = window.localStorage.getItem('myHeaders');
  const storedHeaders = JSON.parse(stringHeaders);

  const closureTORef = useRef(null)
  const closureCCRef = useRef(null)
  const closureBCCRef = useRef(null)
  const [loader, setLoader] = useState(false)

  const [statusCountsMap, setStatusCountMap] = useState()

  const [gloabalTaskListMap, setGloabalTaskListMap] = useState()
  useEffect(() => {
    setLoader(true)
    axios.post(`${url}task/card/get/day`, {
      "empId": selfInfo.empId,
      "date": todayDate
    }
      , { headers: storedHeaders })
      .then(response => {
        setTaskCount(response.data.task.length)
        setCompletedTaskList([])
        setPendingTaskList([])
        setNotStartedTaskList([])
        setDiscussionTaskList([])
        setSubmittedTaskList([])

        const NoImgTskObj = response.data.task.map(task => {
          task.taskOwner.empImg = null;
          return task;
        });

        const statusTasksArray = statuses.map(status => ({
          status: status.status,
          statusId: status.statusId,
          statusColorCode: status.statusColorCode,
          taskList: NoImgTskObj.filter(task => task.statusEntity.statusId === status.statusId)
        }));

        // Now statusTasksArray contains the formatted array of objects
        setUpdatedTskList(statusTasksArray)

        const tempStatusCountsMap = {};
        statusTasksArray.forEach(statusObj => {
          const key = statusObj.status.toLowerCase();
          tempStatusCountsMap[key] = statusObj.taskList.length;
        });

        setStatusCountMap(tempStatusCountsMap)
        setLoader(false)
      })
      .catch(error => {})

    axios.get(`${url}email/emails-list`, { headers: storedHeaders })
      .then(response => {
        selfInfo?.empHigherAuthEmails?.forEach(obj => {
          setGlobalEmailList(response?.data.filter(objKey => obj?.email_key !== objKey?.email_key)) 
        })
      })
      .catch(error => {})
  }, [])




  useEffect(() => {
    function handleOutsideClick(event) {
      if (closureTORef && closureTORef.current && !closureTORef.current.contains(event.target)) {
        SetFlagToEmailList(false)
      } else if (closureCCRef && closureCCRef.current && !closureCCRef.current.contains(event.target)) {
        setFlagCCEmailList(false)
      } else if (closureBCCRef && closureBCCRef.current && !closureBCCRef.current.contains(event.target)) {
        setFlagBCCEmailList(false)
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [])

  // const editor = new EditorJS({
  //   holder: 'editorjs',
  //   placeholder: 'Enter self points...',
  //   tools: {
  //     paragraph: Paragraph,
  //   }
  // });

  function extractPlainText(html) {
    // Replace closing tags with closing tags followed by newline character
    const replacedHtml = html.replace(/<\/(p|h2|h3|h4)>/g, '</$1>\n');

    // Convert HTML to plain text
    const doc = new DOMParser().parseFromString(replacedHtml, 'text/html');
    return doc.body.textContent || '';
  }

  const removeStringParse = (e) => {
    let jsonString = e;
    let jsonObject = JSON.parse(jsonString);
    return jsonObject.editorData
  }

  return (
    <div className='Closure_Main_container'>
      <div className='closure-container'>{
        loader ? <div className='loader-container'>
          <div className='closure-loader'></div>
        </div> : <div className='closure_template'>
          <div className='ClosureMail_heading'>
            <p >Closure Mail</p>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => dispatch(setClosureMail(false))} style={{ cursor: 'pointer' }}>
              <rect width="20" height="20" rx="10" fill="#D9D9D9" />
              <path d="M12.5174 6.32305C12.7402 6.10025 13.1015 6.10025 13.3243 6.32304C13.547 6.54584 13.547 6.90706 13.3243 7.12985L6.78671 13.6674C6.56391 13.8902 6.20269 13.8902 5.9799 13.6674C5.7571 13.4446 5.7571 13.0834 5.9799 12.8606L12.5174 6.32305ZM5.9832 6.32969C6.20857 6.10454 6.57377 6.10462 6.79904 6.32989L13.327 12.8578C13.5524 13.0832 13.5523 13.4487 13.3268 13.674C13.1014 13.8992 12.7362 13.8991 12.5109 13.6739L5.983 7.14593C5.75758 6.92051 5.75767 6.55501 5.9832 6.32969Z" fill="#263238" />
            </svg>
          </div>
          <div className='closure_template_scroller'>
            <div className='closureSentToContainer'>
              <div className='to'>
                <p className='toPara'>To:</p>
                <div className='toClosureDiv' onClick={() => {
                  SetFlagToEmailList(true)
                }}>
                  <div className='toSentMailSelected'>
                    {toEmailList && toEmailList.length > 0 && toEmailList.map((emailObj) => (
                      <div className='toSentMail'>
                        <p>{emailObj.email_key}</p>
                        <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.71751 0.525126C4.91278 0.329864 5.22936 0.329864 5.42462 0.525126C5.61988 0.720388 5.61988 1.03697 5.42462 1.23223L1.18198 5.47487C0.986718 5.67014 0.670136 5.67014 0.474874 5.47487C0.279612 5.27961 0.279612 4.96303 0.474874 4.76777L4.71751 0.525126ZM0.474874 0.525126C0.670136 0.329864 0.986718 0.329864 1.18198 0.525126L5.42355 4.7667C5.61882 4.96196 5.61882 5.27854 5.42355 5.47381C5.22829 5.66907 4.91171 5.66907 4.71645 5.47381L0.474874 1.23223C0.279612 1.03697 0.279612 0.720388 0.474874 0.525126Z" fill="#263238" />
                        </svg>
                      </div>
                    ))}
                  </div>
                  {flagToEmailList &&
                    <div className='emailListContainer' ref={closureTORef}>
                      <div className='seletedToEmailDiv'>
                        <div className='seletedToEmailDivScroller'>
                          {toEmailList && toEmailList.length > 0 && toEmailList.map((emailObj) => (
                            <div className='toSentMail'>
                              <p>{emailObj.email_key}</p>
                              <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                const updatedList = toEmailList.filter(obj => obj !== emailObj);
                                setTOEMailList(updatedList);
                                glabalEmailsList.push(emailObj)
                                setGlobalEmailList(glabalEmailsList)
                              }}>
                                <path d="M4.71751 0.525126C4.91278 0.329864 5.22936 0.329864 5.42462 0.525126C5.61988 0.720388 5.61988 1.03697 5.42462 1.23223L1.18198 5.47487C0.986718 5.67014 0.670136 5.67014 0.474874 5.47487C0.279612 5.27961 0.279612 4.96303 0.474874 4.76777L4.71751 0.525126ZM0.474874 0.525126C0.670136 0.329864 0.986718 0.329864 1.18198 0.525126L5.42355 4.7667C5.61882 4.96196 5.61882 5.27854 5.42355 5.47381C5.22829 5.66907 4.91171 5.66907 4.71645 5.47381L0.474874 1.23223C0.279612 1.03697 0.279612 0.720388 0.474874 0.525126Z" fill="#263238" />
                              </svg>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className='globalEmailListContainer'>
                        {glabalEmailsList && glabalEmailsList.length > 0 && glabalEmailsList.map((emailObj) => (
                          <div className='EmailListContentDiv' onClick={() => {
                            setGlobalEmailList(glabalEmailsList?.filter(obj => obj?.email_key !== emailObj.email_key))
                            if (!toEmailList.map(item => item.email_key).includes(emailObj.email_key)) {
                              // If not present, add it to the list along with existing selected emails
                              setTOEMailList([...toEmailList, emailObj]);
                            }
                          }}>
                            <p>
                              {emailObj.email_key}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  }
                </div>
              </div>
              {ccContainer &&
                <div className='to'>
                  <p className='toPara'>CC:</p>
                  <div className='toClosureDiv' onClick={() => { setFlagCCEmailList(true) }}>
                    <div className='toSentMailSelected'>
                      {ccEmailList && ccEmailList.length > 0 && ccEmailList.map((emailObj) => (
                        <div className='toSentMail ccSentMail'>
                          <p>{emailObj.email_key}</p>
                          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path d="M4.71751 0.525126C4.91278 0.329864 5.22936 0.329864 5.42462 0.525126C5.61988 0.720388 5.61988 1.03697 5.42462 1.23223L1.18198 5.47487C0.986718 5.67014 0.670136 5.67014 0.474874 5.47487C0.279612 5.27961 0.279612 4.96303 0.474874 4.76777L4.71751 0.525126ZM0.474874 0.525126C0.670136 0.329864 0.986718 0.329864 1.18198 0.525126L5.42355 4.7667C5.61882 4.96196 5.61882 5.27854 5.42355 5.47381C5.22829 5.66907 4.91171 5.66907 4.71645 5.47381L0.474874 1.23223C0.279612 1.03697 0.279612 0.720388 0.474874 0.525126Z" fill="#263238" />
                          </svg>
                        </div>
                      ))}
                    </div>
                    <div>
                      {flagCCEmailList &&
                        <div className='emailListContainer' ref={closureCCRef}>
                          <div className='seletedToEmailDiv'>
                            <div className='seletedToEmailDivScroller'>
                              {ccEmailList && ccEmailList.length > 0 && ccEmailList.map((emailObj) => (
                                <div className='toSentMail ccSentMail'>
                                  <p>{emailObj.email_key}</p>
                                  <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                    const updatedList = ccEmailList.filter(obj => obj !== emailObj);
                                    setCCEmailList(updatedList);
                                    glabalEmailsList.push(emailObj)
                                    setGlobalEmailList(glabalEmailsList)
                                  }}>
                                    <path d="M4.71751 0.525126C4.91278 0.329864 5.22936 0.329864 5.42462 0.525126C5.61988 0.720388 5.61988 1.03697 5.42462 1.23223L1.18198 5.47487C0.986718 5.67014 0.670136 5.67014 0.474874 5.47487C0.279612 5.27961 0.279612 4.96303 0.474874 4.76777L4.71751 0.525126ZM0.474874 0.525126C0.670136 0.329864 0.986718 0.329864 1.18198 0.525126L5.42355 4.7667C5.61882 4.96196 5.61882 5.27854 5.42355 5.47381C5.22829 5.66907 4.91171 5.66907 4.71645 5.47381L0.474874 1.23223C0.279612 1.03697 0.279612 0.720388 0.474874 0.525126Z" fill="#263238" />
                                  </svg>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className='globalEmailListContainer' >
                            {glabalEmailsList && glabalEmailsList.length > 0 && glabalEmailsList.map((emailObj) => (
                              <div className='EmailListContentDiv' onClick={() => {
                                //add here code for the append selected email list 
                                setGlobalEmailList(glabalEmailsList?.filter(obj => obj?.email_key !== emailObj.email_key))
                                if (!ccEmailList.includes(emailObj)) {
                                  setCCEmailList([...ccEmailList, emailObj]);
                                }
                              }}>
                                <p>{emailObj.email_key}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              {bccContainer &&
                <div className='to BCC' ref={closureBCCRef}>
                  <p className='toPara'>BCC:</p>
                  <div className='toClosureDiv' onClick={() => { setFlagBCCEmailList(true) }}>
                    <div className='toSentMailSelected'>
                      {bccEmailList && bccEmailList.length > 0 && bccEmailList.map((emailObj) => (
                        <div className='toSentMail bccSentMail'>
                          <p>{emailObj.email_key}</p>
                          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.71751 0.525126C4.91278 0.329864 5.22936 0.329864 5.42462 0.525126C5.61988 0.720388 5.61988 1.03697 5.42462 1.23223L1.18198 5.47487C0.986718 5.67014 0.670136 5.67014 0.474874 5.47487C0.279612 5.27961 0.279612 4.96303 0.474874 4.76777L4.71751 0.525126ZM0.474874 0.525126C0.670136 0.329864 0.986718 0.329864 1.18198 0.525126L5.42355 4.7667C5.61882 4.96196 5.61882 5.27854 5.42355 5.47381C5.22829 5.66907 4.91171 5.66907 4.71645 5.47381L0.474874 1.23223C0.279612 1.03697 0.279612 0.720388 0.474874 0.525126Z" fill="#263238" />
                          </svg>
                        </div>
                      ))}
                    </div>
                    <div>
                      {flagBCCEmailList &&
                        <div className='emailListContainer'>
                          <div className='seletedToEmailDiv'>
                            <div className='seletedToEmailDivScroller'>
                              {bccEmailList && bccEmailList.length > 0 && bccEmailList.map((emailObj) => (
                                <div className='toSentMail bccSentMail'>
                                  <p>{emailObj.email_key}</p>
                                  <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                    const updatedList = bccEmailList.filter(obj => obj !== emailObj);
                                    setBCCEmailList(updatedList);
                                    glabalEmailsList.push(emailObj)
                                    setGlobalEmailList(glabalEmailsList)
                                  }}>
                                    <path d="M4.71751 0.525126C4.91278 0.329864 5.22936 0.329864 5.42462 0.525126C5.61988 0.720388 5.61988 1.03697 5.42462 1.23223L1.18198 5.47487C0.986718 5.67014 0.670136 5.67014 0.474874 5.47487C0.279612 5.27961 0.279612 4.96303 0.474874 4.76777L4.71751 0.525126ZM0.474874 0.525126C0.670136 0.329864 0.986718 0.329864 1.18198 0.525126L5.42355 4.7667C5.61882 4.96196 5.61882 5.27854 5.42355 5.47381C5.22829 5.66907 4.91171 5.66907 4.71645 5.47381L0.474874 1.23223C0.279612 1.03697 0.279612 0.720388 0.474874 0.525126Z" fill="#263238" />
                                  </svg>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className='globalEmailListContainer'>
                            {glabalEmailsList && glabalEmailsList.length > 0 && glabalEmailsList.map((emailObj) => (
                              <div className='EmailListContentDiv' onClick={() => {
                                //add here code for the append selected email list 
                                setGlobalEmailList(glabalEmailsList?.filter(obj => obj?.email_key !== emailObj.email_key))
                                if (!bccEmailList.includes(emailObj)) {
                                  setBCCEmailList([...bccEmailList, emailObj]);
                                }
                              }}>
                                <p>{emailObj.email_key}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              <div className='mail_options'>
                <p style={{ cursor: 'pointer' }} onClick={() => { setCCConatiner(!ccContainer) }}>CC</p>
                <p style={{ cursor: 'pointer' }} onClick={() => { setBCCConatiner(!bccContainer) }}>BCC</p>
              </div>
            </div>
            <div className='closureHeadingSubjectDiv'>
              {`Daily Closure report: ${todayDate}`}
            </div>
            <div className='closure-report-Content'>
              <div className='dearSir'>Respected Sir,</div>
              <div className='reportHeading'>
                Today's work report is as follows-
              </div>

              {updatedtskList && updatedtskList.length > 0 && updatedtskList.map((obj) => (
                <div className='clousreTaskView'>
                  <div style={{ backgroundColor: obj?.statusColorCode ? `${obj.statusColorCode}` : null }} className='Completedcount notStartedCount'>{`${obj.status}(${obj.taskList.length})`}</div>
                  {obj.taskList && obj.taskList.length > 0 && obj.taskList.map((obj, index) => (
                    <div className='sortedTaskInShortDiv'>
                      <div className='completedListForClosure' onMouseEnter={() => {
                        setClosureTaskDetailView(true)
                        setTaskIdForView(obj.taskId)

                      }} onMouseLeave={() => {
                        setClosureTaskDetailView(false)
                        setTaskIdForView(obj.taskId)
                      }}>
                        <div className='closureTaskTitleContainer'>{`${index + 1}. ${obj.taskTitle.length > 30 ? obj.taskTitle.substring(0, 25) + '...' : obj.taskTitle}`}</div>
                        <div className='closureTaskProjectAndDateContainer'>
                          <p style={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'left' }}> {obj.projectEntity ?
                            (obj.projectEntity.projectName.length > 10 ?
                              obj.projectEntity.projectName.substring(0, 10) + '...'
                              : obj.projectEntity.projectName)
                            : '-'
                          }</p>
                          <p>{`${obj.taskDueDate}`}</p>
                        </div>
                      </div>

                      {obj.taskId === taskIdForView && closureTaskDetaiView &&
                        <div className='onHoverClsoureTaskDetails'>
                          <div className='onHoverClsoureProjectName'>
                            <p style={{ width: 'fit-content', color: '#26323852' }}>Project Name::</p>
                            {obj.projectEntity ? obj.projectEntity?.projectName : 'No Project'}
                          </div>

                          <div className='onHoverClsoureTaskTitle'>
                            <p style={{ width: '100%', color: '#26323852' }}>TaskTitle::</p>
                            {obj.taskTitle}
                          </div>
                          <div className='onHoverClsoureTaskTitle' style={{width: '100%', height: 'auto', zIndex: '99999'}}>
                            <p style={{ width: '100%', color: '#26323852', height: 'auto'}}>Task Comments::</p>
                            {obj.taskComment !== null ? extractPlainText(removeStringParse(obj?.taskComment)) : 'No Comment'}
                          </div>
                          <div className='onHoverClsoureTaskTitle' style={{width: '100%', height: 'auto', zIndex: '99999'}}>
                            <p style={{ width: '100%', color: '#26323852' }}>Start Time - End Time</p>
                            {obj.taskTimeFrom !== null ? obj.taskTimeFrom : '-' }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{obj.taskTimeTo !== null ? obj.taskTimeTo : '-'}
                          </div>
                        </div>
                      }
                    </div>
                  ))}
                </div>
              ))}

              {/* <div className='selfPointEditorJs'>
                <div id="editorjs">
                </div>
              </div> */}

              <div className='thanks_regrads'>
                <p style={{ fontWeight: '700' }}>Warm Regards,</p>
              </div>
              <div className='emailSignature'>
                <div className='incubator-logo'><img src={incubatorLogo} alt="" /></div>
                <div className='middle-div-line'></div>
                <div className='right-signature-content'>
                  <p style={{ fontSize: '25px', fontWeight: '700', color: 'rgb(69, 69, 69)' }}>{selfInfo.empFullName}</p>
                  <p style={{ fontSize: '18px', color: ' rgb(255, 0, 0)', fontWeight: '600' }}>{selfInfo.designation.designation}</p>
                  <p style={{ marginTop: '10px', fontSize: '14px', color: '#00000082' }}>{selfInfo.empMobile1}</p>
                  <p style={{ marginTop: '2px', fontSize: '14px', color: '#00000082' }}>{selfInfo.empEmailOfficial}</p>
                  <p style={{ marginTop: '2px', fontSize: '14px', color: '#00000082' }}><a href='https://biencaps.com' >www.biencaps.com</a></p>
                </div>
              </div>

            </div>
          </div>
          <div className='sendBtnClosureMailDiv'>
            <div className='closure_del_link'>
              {/* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.2 3.07317H10.8C10.8 2.60742 10.6104 2.16075 10.2728 1.83142C9.93523 1.50209 9.47739 1.31707 9 1.31707C8.52261 1.31707 8.06477 1.50209 7.72721 1.83142C7.38964 2.16075 7.2 2.60742 7.2 3.07317ZM5.85 3.07317C5.85 2.6696 5.93148 2.26997 6.08978 1.89712C6.24808 1.52427 6.48011 1.18548 6.77261 0.900111C7.06512 0.614741 7.41237 0.388373 7.79455 0.233931C8.17672 0.0794899 8.58634 0 9 0C9.41366 0 9.82328 0.0794899 10.2055 0.233931C10.5876 0.388373 10.9349 0.614741 11.2274 0.900111C11.5199 1.18548 11.7519 1.52427 11.9102 1.89712C12.0685 2.26997 12.15 2.6696 12.15 3.07317H17.325C17.504 3.07317 17.6757 3.14255 17.8023 3.26605C17.9289 3.38955 18 3.55705 18 3.73171C18 3.90636 17.9289 4.07386 17.8023 4.19736C17.6757 4.32086 17.504 4.39024 17.325 4.39024H16.137L15.084 15.0243C15.0032 15.8391 14.6142 16.5953 13.9929 17.1455C13.3716 17.6957 12.5625 18.0003 11.7234 18H6.2766C5.43768 18.0001 4.62879 17.6954 4.00765 17.1452C3.38652 16.5951 2.99766 15.839 2.9169 15.0243L1.863 4.39024H0.675C0.495979 4.39024 0.32429 4.32086 0.197703 4.19736C0.0711158 4.07386 0 3.90636 0 3.73171C0 3.55705 0.0711158 3.38955 0.197703 3.26605C0.32429 3.14255 0.495979 3.07317 0.675 3.07317H5.85ZM7.65 7.2439C7.65 7.06925 7.57888 6.90175 7.4523 6.77825C7.32571 6.65475 7.15402 6.58537 6.975 6.58537C6.79598 6.58537 6.62429 6.65475 6.4977 6.77825C6.37112 6.90175 6.3 7.06925 6.3 7.2439V13.8293C6.3 14.0039 6.37112 14.1714 6.4977 14.2949C6.62429 14.4184 6.79598 14.4878 6.975 14.4878C7.15402 14.4878 7.32571 14.4184 7.4523 14.2949C7.57888 14.1714 7.65 14.0039 7.65 13.8293V7.2439ZM11.025 6.58537C11.204 6.58537 11.3757 6.65475 11.5023 6.77825C11.6289 6.90175 11.7 7.06925 11.7 7.2439V13.8293C11.7 14.0039 11.6289 14.1714 11.5023 14.2949C11.3757 14.4184 11.204 14.4878 11.025 14.4878C10.846 14.4878 10.6743 14.4184 10.5477 14.2949C10.4211 14.1714 10.35 14.0039 10.35 13.8293V7.2439C10.35 7.06925 10.4211 6.90175 10.5477 6.77825C10.6743 6.65475 10.846 6.58537 11.025 6.58537ZM4.2606 14.8979C4.30914 15.3866 4.54252 15.8402 4.91523 16.1702C5.28794 16.5003 5.77327 16.683 6.2766 16.6829H11.7234C12.2267 16.683 12.7121 16.5003 13.0848 16.1702C13.4575 15.8402 13.6909 15.3866 13.7394 14.8979L14.7816 4.39024H3.2184L4.2606 14.8979Z" fill="#263238" fill-opacity="0.6" />
              </svg>
              <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 0H12C11.45 0 11 0.45 11 1C11 1.55 11.45 2 12 2H15C16.65 2 18 3.35 18 5C18 6.65 16.65 8 15 8H12C11.45 8 11 8.45 11 9C11 9.55 11.45 10 12 10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0ZM6 5C6 5.55 6.45 6 7 6H13C13.55 6 14 5.55 14 5C14 4.45 13.55 4 13 4H7C6.45 4 6 4.45 6 5ZM8 8H5C3.35 8 2 6.65 2 5C2 3.35 3.35 2 5 2H8C8.55 2 9 1.55 9 1C9 0.45 8.55 0 8 0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H8C8.55 10 9 9.55 9 9C9 8.45 8.55 8 8 8Z" fill="#263238" fill-opacity="0.6" />
              </svg> */}
            </div>
            <div className='closure_send_btn'>
              <button
                onClick={loaderBtn ? null : () => {
                  setLoaderBtn(true)
                  const ToEmailArray = toEmailList.map(obj => obj.email_key);
                  const CCEmailArray = ccEmailList.map(obj => obj.email_key);
                  const BCCEmailArray = bccEmailList.map(obj => obj.email_key)
                  const inputDate = todayDate;
                  const dateParts = inputDate.split('/');

                  // Create a Date object
                  const date = new Date(`${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`);

                  // Array of month names
                  const months = [
                    "January", "February", "March", "April", "May", "June", "July",
                    "August", "September", "October", "November", "December"
                  ];

                  // Get day, month, and year
                  const day = date.getDate();
                  const monthIndex = date.getMonth();
                  const year = date.getFullYear();

                  // Format the date
                  const formattedDate = `${day} ${months[monthIndex]} ${year}`;
                  var sendBody = (`Today's work report is as follows--\n\nTotal Task count: ${taskCount}\n\n`);
                  updatedtskList.map((obj) => {
                    let tempStr = obj.taskList.length > 0 ? obj.taskList.map((task, index) => `${index + 1}. ${task.taskTitle}\n\t    Due Date: ${task.taskDueDate}\t\tTask Owner : ${task.taskOwner.empFullName}\t\tProject Name: ${task.projectEntity !== null ? task.projectEntity.projectName : '-'}\t\tTime: ${(task.taskTimeFrom !== null ? task.taskTimeFrom : '-') + '-' + (task.taskTimeTo !== null ? task.taskTimeTo : '-')}\n\t    Task Comment: ${task.taskComment ? extractPlainText(removeStringParse(task?.taskComment)) : '-'}\n`).join('\n\t') : '-'
                    sendBody = sendBody + `${obj.status} Tasks\n\t` + `${tempStr}` + '\n\n'
                  })


                  sendBody = sendBody + `Warm regards,\n\n${selfInfo.empFullName}\n${selfInfo.designation.designation}\n${selfInfo.empMobile1}\n${selfInfo.empEmailOfficial}\nwww.biencaps.com`;
                  var strBody = JSON.stringify(updatedtskList)
                  axios.post(
                    `${url}email/send`,
                    {
                      "emailMap": {
                        "loginId": selfInfo.userId,
                        "subject": `Closure Report:: ${formattedDate}`,
                        "body": sendBody
                      },

                      "emailTo": ToEmailArray.length > 0 ? ToEmailArray : null,
                      "emailCc": CCEmailArray.length > 0 ? CCEmailArray : null,
                      "emailBcc": BCCEmailArray.length > 0 ? BCCEmailArray : null,
                      "count": statusCountsMap,
                      "jMailMap": JSON.stringify(updatedtskList),
                      "empMobile": selfInfo.empMobile1,
                      "empEmailOfficial": selfInfo.empEmailOfficial

                    },
                    { headers: storedHeaders }
                  )
                    .then(response => {
                      if (response.request.status === 200) {
                        dispatch(setClosureMail(false))
                        setLoaderBtn(false)
                        toast.success(`Mail send successfully`, { autoClose: 2000 })
                      }
                    })
                    .catch(error => {
                      setLoaderBtn(false)
                      toast.error(`Please add the email in to : `, { autoClose: 2000 })
                    })
                }}
              >{loaderBtn ? <div className='btnLoader' /> : "Send"}</button>
            </div>
          </div>
        </div>
      }

      </div>
    </div>
  )
}

export default ClosureMail


